//src/pages/Welcome.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReminderSettings } from '../components/ReminderSettings';
import { Button } from '../components/Button';
import { ArrowRight } from 'lucide-react';
import { ProtectedLayout } from '../components/ProtectedLayout';

export function Welcome() { 
  const navigate = useNavigate();
  const location = useLocation();
  const [amount, setAmount] = useState<number | null>(null);
  const [monthly, asetMonthly] = useState<number | null>(null);
  const [fullName, setFullName] = useState<string>('');

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const amountParam = searchParams.get('amount');
    const monthlyParam = searchParams.get('monthly');
    const nameParam = searchParams.get('name');

    if (amountParam) setAmount(parseFloat(amountParam));
    if (monthlyParam) setMonthly(parseFloat(monthlyParam));
    if (nameParam) setFullName(decodeURIComponent(nameParam));
  }, [location.search]);

  const firstName = fullName.split(' ')[0] || 'Friend';

  return (
     <ProtectedLayout>
      <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 flex items-center justify-center p-6">
        <div className="max-w-3xl w-full bg-white rounded-xl shadow-lg p-8 space-y-8">
          <div className="flex justify-center mb-6">
            <img
              src="/winning-resolutions-logo copy.png"
              alt="Winning Resolutions"
              className="h-20 w-auto"
            />
          </div>
          <h1 className="text-3xl font-bold text-[#004060] text-center">
            Congrats on investing in yourself, {firstName}!
          </h1>

          <div className="space-y-4 text-lg text-gray-700">
            {monthly !== null && (
              <p>
                Your monthly payment is{' '}
                <span className="font-bold text-[#004060]">${monthly.toFixed(2)}</span> and will start on the 1st of next month.
              </p>
            )}

            {amount !== null && (
              <p>
                Today, you were charged a prorated amount of{' '}
                <span className="font-bold text-[#004060]">${(amount / 100).toFixed(2)}</span>.
              </p>
            )}

            <p>
              The next step is a one-time onboarding to set you up for success. You’ll:
            </p>

            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Identify your 3 core values in just 3 questions</li>
              <li>Set personalized reminders to keep you in action</li>
            </ul>

            <p>
              You’ve already taken a powerful step. I’m here for you. When you're ready, let’s move forward.
            </p>
          </div>

          <div className="flex gap-4">
            <Button variant="outline" onClick={() => navigate('/pricing')} className="w-1/2">
              Back
            </Button>
            <Button onClick={() => navigate('/impact-intentions')} className="w-1/2 flex items-center justify-center gap-2">
              Begin Onboarding
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
     </ProtectedLayout>
  );
}
